export default {
  Link: {
    baseStyle: {
      textDecoration: 'underline',
    },
    sizes: {},
    variants: {},
    defaultProps: {},
  },
};
